import { render, staticRenderFns } from "./CoursesSpeaking.vue?vue&type=template&id=7a56b520&scoped=true&"
import script from "./CoursesSpeaking.vue?vue&type=script&lang=js&"
export * from "./CoursesSpeaking.vue?vue&type=script&lang=js&"
import style0 from "./CoursesSpeaking.vue?vue&type=style&index=0&id=7a56b520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a56b520",
  null
  
)

export default component.exports